import * as React from 'react';
import { Button } from '@teamsnap/teamsnap-ui';
import api from 'core/api';
import { reactiveFeedbackMessage } from 'core/apollo-cache';
import StoredDocumentViewerModal from './StoredDocumentViewerModal';

interface Props {
  internalUrl: string;
  openInModal: boolean;
}

const StoredDocumentViewer = ({ children, internalUrl, openInModal }: React.PropsWithChildren<Props>) => {
  const [showDocumentViewerModal, setShowDocumentViewerModal] = React.useState<boolean>(false);
  const [documentUrl, setDocumentUrl] = React.useState<string>('');
  const viewerAction = (): void => {
    api
      .get<{ url: string }>(internalUrl)
      .then((result) => {
        setDocumentUrl(result.data?.url);
        openInModal ? setShowDocumentViewerModal(true) : window.open(documentUrl, '_blank');
      })
      .catch((e) => {
        reactiveFeedbackMessage({
          message: 'Failed to fetch stored document.',
          autoclose: true,
          isError: true,
        });
        console.error(`StoredDocumentViewer::viewerAction(): ${e}`);
      });
  };

  return (
    <>
      {internalUrl && (
        <div id="stored-document-viewer">
          <StoredDocumentViewerModal
            documentUrl={documentUrl}
            show={showDocumentViewerModal}
            onClose={() => setShowDocumentViewerModal(false)}
          />
          <Button onClick={viewerAction} type="link">
            {children}
          </Button>
        </div>
      )}
    </>
  );
};

export default StoredDocumentViewer;
